import axios from './axiosConfig'

export interface DiningHall {
 id: string
 branch_id: string
 name: string
 description: string | null
 sort_order: number
 is_active: boolean
 tables?: DiningTable[]
 created_at: string
 updated_at: string
}

export interface DiningTable {
 id: string
 dining_hall_id: string
 branch_id: string
 name: string
 number: string | null
 capacity: number
 shape: 'square' | 'round' | 'rectangle'
 position_x: number
 position_y: number
 status: 'available' | 'occupied' | 'reserved' | 'closed'
 current_order_id: string | null
 draft_generation?: number
 dining_hall?: DiningHall
 current_order?: any
 created_at: string
 updated_at: string
}

type ApiList = { status: string; data: DiningHall[]; message?: string }
type ApiOne = { status: string; data: DiningHall; message?: string }

export const diningHallsAPI = {
 list: async (branchId: string) => {
 const response = await axios.get<ApiList>(`/branches/${branchId}/dining-halls`, {
 headers: { 'X-Branch-Id': branchId },
 })
 return response.data
 },

 listForPos: async (branchId: string) => {
 const response = await axios.get<ApiList>('/pos/dining-halls', {
 headers: { 'X-Branch-Id': branchId },
 })
 return response.data
 },

 get: async (id: string) => {
 const response = await axios.get<ApiOne>(`/dining-halls/${id}`)
 return response.data
 },

 create: async (branchId: string, payload: Record<string, unknown>) => {
 const response = await axios.post<ApiOne>(`/branches/${branchId}/dining-halls`, payload, {
 headers: { 'X-Branch-Id': branchId },
 })
 return response.data
 },

 update: async (id: string, payload: Record<string, unknown>) => {
 const response = await axios.put<ApiOne>(`/dining-halls/${id}`, payload)
 return response.data
 },

 delete: async (id: string) => {
 const response = await axios.delete(`/dining-halls/${id}`)
 return response.data
 },
}
